import React from 'react';
import PropTypes from 'prop-types';

import useSuspenseQuery from 'commons/useSuspenseQuery';
import SidebarModal from 'components/consumer/SidebarModal';
import ProductImage from 'components/consumer/cart/components/ProductImage';
import PDPFabricUpChargeModalUI from 'components/consumer/PDP/PDPFabricUpChargeModal/PDPFabricUpChargeModalUI';
import { GET_ORDER_INFO, GET_ORDER_UPCHARGE_SUMMARY } from 'mocks/queries';
import withBrowserOnly from 'components/hoc/withBrowserOnly';

const UserProtectionPlanModal = ({
  cartItem,
  onClose,
  orderId,
  purchaseErrorMessage,
  selectedPlan,
  updateOrder,
}) => {
  const { data: orderInfo, error: orderError } = useSuspenseQuery(
    GET_ORDER_INFO,
    {
      variables: {
        order_id: orderId,
      },
      skip: !orderId,
    }
  );

  const { data: summaryData, error: summaryError } = useSuspenseQuery(
    GET_ORDER_UPCHARGE_SUMMARY,
    {
      variables: {
        input: {
          order_id: orderId,
          cart_item_id: cartItem.cart_id,
          plan_id: selectedPlan.plan_id?.toString(),
        },
      },
    }
  );

  if (summaryError || orderError) {
    return null;
  }

  const upChargeSummary = summaryData?.getOrderItemUpChargeSummary;

  return (
    <SidebarModal isOpen onClose={onClose}>
      <PDPFabricUpChargeModalUI
        cartImg={
          <ProductImage
            product={cartItem}
            width={50}
            trim="color"
            trimPad={20}
          />
        }
        cartItem={cartItem}
        errorMessage={purchaseErrorMessage}
        isInSidebarModal
        orderId={orderId}
        orderInfo={orderInfo?.getOrderInfo?.order}
        paymentMethods={upChargeSummary?.methods}
        selectedPlan={selectedPlan}
        upChargeSummary={upChargeSummary?.summary}
        updateOrder={updateOrder}
      />
    </SidebarModal>
  );
};

UserProtectionPlanModal.propTypes = {
  cartItem: PropTypes.shape({
    cart_id: PropTypes.string,
    name: PropTypes.string,
    quantity: PropTypes.number,
    slug: PropTypes.string,
  }),
  onClose: PropTypes.func,
  orderId: PropTypes.string,
  purchaseErrorMessage: PropTypes.node,
  selectedPlan: PropTypes.shape({
    plan_id: PropTypes.string,
    plan_name: PropTypes.string,
  }),
  updateOrder: PropTypes.func,
};

export default withBrowserOnly(UserProtectionPlanModal);
